// import myStore from "../stores/store";

export function stater(store,code) {
  return {
    linker: {
      set value(val){
        // myStore.formStore.updateHappened();
        store.setState({ [code]:val });
      },
      get value(){
        return typeof store.state[code] === 'undefined'?'':store.state[code];
      }
    }
  }
}

export function custom(store,code) {
  return {
    linker: {
      set value(val){
        // myStore.formStore.updateHappened();
        store[code]=typeof val === 'undefined'?'':val;
      },
      get value(){
        return typeof store[code] === 'undefined'?'':store[code];
      }
    }
  }
}

export function checkbox(store,code) {
  return {
    checked: typeof store[code] === 'undefined' || parseInt(store[code]) === 0?false:true,
    onChange: (e) => {
      if(e.target.checked) {
        store[code]=1;
      } else {
        store[code]=0;
      }
    }
  }
}

export function input(store,code) {
  return {
    value: typeof store[code] === 'undefined' || store[code] === null?'':store[code],
    onChange: (e) => {
      // console.log('e.target.value',e.target.value);
      store[code] = e.target.value;
    }
  }
}